import React from 'react'
import { useSelector } from 'react-redux'
import TableWithCheckbox from '@groovehq/internal-design-system/lib/components/TableWithCheckbox/TableWithCheckbox'
import { selectMailboxesIncludingInaccessible } from 'selectors/mailboxes'
import useColumns from './useColumns'

const MailboxSelectionTable = ({
  onSelectedRowIdsChange,
  defaultSelectedRowIds,
}) => {
  const columns = useColumns()

  const mailboxes = useSelector(selectMailboxesIncludingInaccessible)

  return (
    <TableWithCheckbox
      columns={columns}
      onSelectedRowIdsChange={onSelectedRowIdsChange}
      data={mailboxes}
      defaultSelectedRowIds={defaultSelectedRowIds}
    />
  )
}

export default MailboxSelectionTable
